import { render, staticRenderFns } from "./LinkedInIcon.vue?vue&type=template&id=d9f8edb6&scoped=true&"
import script from "./LinkedInIcon.vue?vue&type=script&lang=js&"
export * from "./LinkedInIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9f8edb6",
  null
  
)

export default component.exports